export const voiceAgent = {
  header: {
    title: "Agente vocale AI",
    subBefore: "Risponde alle tue chiamate telefoniche con AI in tempo reale. Si applica a",
    subEmphasis: "tutto il tuo account",
    active: "Attivo",
    inactive: "Inattivo",
  },
  loading: "Caricamento della configurazione…",
  errors: {
    load: "Impossibile caricare la configurazione.",
    save: "Impossibile salvare. Riprova.",
  },
  phone: {
    title: "Numero di telefono",
    desc: "Il numero che i tuoi ospiti chiamano. Ne viene creato uno dedicato per il tuo account.",
    checking: "Verifica del tuo numero…",
    pendingTitle: "Telefonia in attesa di attivazione",
    pendingText: "La creazione del numero non è ancora abilitata sul tuo account. Contattaci e la attiveremo.",
    activeCountry: "Attivo · paese {country}",
    provisioning: "Provisioning in corso… (può richiedere qualche minuto)",
    release: "Rilascia",
    numberCountry: "Paese del numero",
    searching: "Ricerca in corso…",
    seeAvailable: "Vedi disponibili",
    perMonth: "{cost}/mese",
    getThis: "Ottieni questo numero",
    getOne: "Ottieni un numero",
    confirmRelease: "Sei sicuro di voler rilasciare il numero? Smetterà di ricevere chiamate.",
    errNoneInCountry: "Nessun numero disponibile in questo paese al momento.",
    errTelnyxInactive: "La telefonia non è ancora attiva sul tuo account.",
    errSearchFailed: "Impossibile cercare i numeri.",
    errTelnyxInactiveContact: "La telefonia non è ancora attiva sul tuo account. Contattaci e la abiliteremo.",
    errNoNumbersNow: "Nessun numero disponibile al momento.",
    errProvisionFailed: "Impossibile ottenere il numero.",
    errReleaseFailed: "Impossibile rilasciare il numero.",
  },
  voiceLang: {
    title: "Voce e lingua",
    assistantVoice: "Voce dell'assistente",
    recommended: "(consigliata)",
    listenVoiceTitle: "Ascolta la voce {voice}",
    loading: "Caricamento…",
    stop: "Ferma",
    listen: "Ascolta",
    mainLanguage: "Lingua principale",
    extraLanguages: "Lingue aggiuntive che può parlare",
    useIdentityTitle: "Usa l'identità dell'agente chat",
    useIdentityDesc: "Riutilizza il nome, la personalità e il tono che hai già impostato nelle Impostazioni generali.",
    voiceAssistantName: "Nome dell'assistente vocale",
    namePlaceholder: "es. reception Málaga Centro Suites",
    greeting: "Saluto alla risposta",
    optional: "(facoltativo)",
    greetingPlaceholder: "Se lasciato vuoto, l'assistente saluta automaticamente con la sua identità.",
    errPlayback: "Impossibile riprodurre il campione.",
    errGenerate: "Impossibile generare il campione vocale. Riprova.",
  },
  languages: {
    es: "Spagnolo",
    en: "Inglese",
    fr: "Francese",
    pt: "Portoghese",
    it: "Italiano",
    de: "Tedesco",
    ar: "Arabo",
  },
  countries: {
    ES: "Spagna",
    US: "Stati Uniti",
    GB: "Regno Unito",
    FR: "Francia",
    IT: "Italia",
    DE: "Germania",
    PT: "Portogallo",
    CO: "Colombia",
    MX: "Messico",
  },
  days: {
    mon: "Lun",
    tue: "Mar",
    wed: "Mer",
    thu: "Gio",
    fri: "Ven",
    sat: "Sab",
    sun: "Dom",
  },
  listings: {
    title: "Strutture per cui risponde",
    desc: "Scegli per quali strutture l'agente vocale risponde alle chiamate.",
    all: "Tutte le strutture",
    some: "Solo alcune",
    scopeNoteBefore: "Risponde per",
    scopeNoteStrong: "tutte",
    scopeNoteAfter: "le strutture dell'account, comprese quelle che aggiungerai in futuro.",
    searchPlaceholder: "Cerca struttura…",
    selectAll: "Seleziona tutto",
    clearAll: "Deseleziona tutto",
    loadingListings: "Caricamento delle strutture…",
    noListings: "Questo account non ha strutture.",
    noMatches: "Nessun risultato.",
    noneWarn: "Se non ne selezioni nessuna, l'agente risponderà per tutte.",
    allDesc: "Compresi quelli che aggiungerai in futuro.",
    someDesc: "Solo quelli che selezioni qui sotto.",
    selectedShort: "{n} di {total}",
  },
  capabilities: {
    title: "Cosa può fare",
    knowledgeTitle: "Da dove prende le informazioni",
    knowledgeDesc: "Scegli cosa consulta l'assistente quando gli chiedono dell'alloggio.",
    messagesTitle: "Prendere messaggi",
    messagesDesc: "Se non sa qualcosa, prende il messaggio dell'ospite e ti avvisa.",
    linksTitle: "Inviare link dopo la chiamata",
    linksDesc: "Dopo aver riagganciato, invia il link utile (check-in o prenotazione) via WhatsApp quando è pertinente.",
    photosTitle: "Inviare le foto di dotazioni e comfort",
    photosDesc: "Se chi chiama chiede di una dotazione che ha foto, l'agente le invia via WhatsApp al numero da cui sta chiamando.",
  },
  doc: {
    title: "Documento con informazioni",
    desc: "Carica un PDF o un Word e l'agente potrà rispondere con quello che c'è dentro.",
    dropTitle: "Carica un documento",
    dropHint: "PDF o Word (.docx), fino a 15 MB",
    uploading: "Caricamento del documento…",
    replace: "Sostituisci",
    remove: "Rimuovi",
    chars: "{n} caratteri letti",
    noText: "Questo documento è scansionato: sono immagini e il testo non si può leggere. Caricane uno con testo vero.",
    errType: "Il file deve essere PDF o Word (.docx).",
    errSize: "Il file non può superare i 15 MB.",
    errUpload: "Non è stato possibile caricare il documento. Riprova.",
    errRemove: "Non è stato possibile rimuovere il documento. Riprova.",
    fuenteBase: "La base di conoscenza",
    fuenteBaseDesc: "La scheda dei tuoi alloggi: check-in, servizi, regole e FAQ.",
    fuenteDoc: "Un documento tuo",
    fuenteDocDesc: "Solo il PDF o Word che carichi qui sotto, con le sue istruzioni.",
    fuenteAmbas: "Entrambe",
    fuenteAmbasDesc: "Prima il documento e, se la risposta non c'è, la scheda dell'alloggio.",
    verTexto: "Vedere cosa legge l'assistente",
    abrirOriginal: "Aprire il documento",
    previewTitle: "Quello che l'assistente legge del tuo documento",
    previewSub: "È il testo estratto dal file. Se qui manca qualcosa, l'assistente non lo sa nemmeno.",
    previewVacio: "Non è stato possibile estrarre testo da questo file.",
    cerrar: "Chiudere",
    noUsado: "È caricato, ma l'assistente non lo sta usando: hai scelto di rispondere solo con la base di conoscenza.",
    faltaDoc: "Carica un documento per poterlo scegliere come fonte.",
  },
  hours: {
    title: "Orari del servizio",
    specific: "Orari specifici",
    closed: "Chiuso",
    afterHours: "Fuori orario",
    afterVoicemail: "Prendere un messaggio vocale",
    afterMessage: "Riprodurre un avviso e riagganciare",
    afterMessagePlaceholder: "Messaggio riprodotto fuori orario.",
  },
  recording: {
    title: "Registrazione e conformità",
    recordTitle: "Registrare le chiamate",
    recordDesc: "Salva l'audio delle chiamate per poterlo riascoltare.",
    noticeTitle: "Annunciare la registrazione",
    noticeDesc: "L'assistente comunica all'inizio che la chiamata potrebbe essere registrata (consigliato ai sensi del GDPR).",
    transcribeTitle: "Trascrivere le chiamate",
    transcribeDesc: "Genera un testo di ogni conversazione.",
    transcribeNeedsRecord: "La trascrizione si ricava dall'audio: con «Registrare le chiamate» spento non se ne genera nessuna.",
  },
  advanced: {
    title: "Avanzate",
    maxDuration: "Durata massima della chiamata",
    minutesOption: "{n} minuti",
    aiEngine: "Motore AI",
  },
  save: {
    saved: "Salvato ✓",
    save: "Salva le modifiche",
    dirty: "Hai modifiche non salvate",
    clean: "Tutto salvato",
  },
  credits: {
    title: "Minuti di chiamata",
    desc: "Minuti inclusi ogni mese in base ai tuoi alloggi. Quando finiscono, ricarica quando vuoi.",
    loading: "Caricamento del saldo…",
    minutesLeft: "min disponibili",
    recharge: "Ricarica",
    includedThisMonth: "{used} di {total} min inclusi usati questo mese",
    purchased: "{min} min acquistati",
    empty: "Hai finito i minuti. Ricarica per continuare a ricevere chiamate.",
    error: "Impossibile caricare il saldo.",
    modal: {
      title: "Ricarica minuti",
      sub: `Scegli un pacchetto. Il pagamento è unico e i minuti vengono aggiunti al saldo all'istante.`,
      pay: "Paga con carta",
      secure: "Pagamento sicuro con Stripe.",
      close: "Chiudi",
      error: "Impossibile avviare il pagamento. Riprova.",
    },
  },
};
